const axios = require("axios");

//TODO: general header check

import * as Cookies from "js-cookie";

import { EventBus } from "../components/EventBus";

const cookies = Cookies.withAttributes({
  domain: process.env.VUE_APP_COOKIE_DOMAIN,
});

class User {
  constructor() {
    if (!User.instance) {
      User.instance = this;
    }
    return User.instance;
  }
  register(user) {
    return (
      axios
        // .post(process.env.VUE_APP_PUMAS_API_URL + "user/register", user)
        .post(process.env.VUE_APP_PUMAS_API_URL + "user/register", user)
        .then((response) => {
          console.log(response);

          this.user = response.data;

          cookies.set("flj-user", JSON.stringify(this.user));

          EventBus.$emit("user-state-change", this.user);

          return;
        })
    );
    console.log("Register called");
  }
  login(user) {
    return axios
      .post(process.env.VUE_APP_PUMAS_API_URL + "user/login", user)
      .then((response) => {
        this.user = response.data;

        cookies.set("flj-user", JSON.stringify(this.user));
        EventBus.$emit("user-state-change", this.user);
        return;
      })
      .catch((error) => {
        //console.log('error login')
        //console.log(error)
        throw new Error(error);
      });
  }
  logout() {
    this.user = null;
    cookies.remove("flj-user");
    EventBus.$emit("user-state-change", this.user);

    return;
  }
  forgot(email) {
    return axios
      .post(process.env.VUE_APP_PUMAS_API_URL + "user/forgot", email)
      .then((response) => {
        console.log(response);
        return;
      })
      .catch((error) => {
        //console.log('error login')
        console.log(error);

        throw new Error(error);
      });
  }
  reset(password, uid, token) {
    return axios
      .post(process.env.VUE_APP_PUMAS_API_URL + "user/reset", {
        password: password,
        uid: uid,
        token: token,
      })
      .then((response) => {
        const user = response.data;
        return this.login({
          email: user.email,
          password: password,
        }).catch((error) => {
          console.log("error login");
          console.log(error);

          throw new Error(error);
        });
      })
      .catch((error) => {
        console.log("hopla");
        //console.log('error login')
        //console.log(error.response.status);
        if (error.response.status === 400) {
          const newError = new Error(error);
          newError.status = 400;
          throw newError;
        } else {
          throw new Error(error);
        }
      });
  }
  get() {
    return new Promise((resolve, reject) => {
      if (this.user) {
        return resolve(this.user);
      }

      const cookieData = JSON.parse(cookies.get("flj-user"));

      if (cookieData) {
        this.user = Object.assign(cookieData, {});

        return resolve(this.user);
      } else {
        this.user = null;
        return reject("no user");
      }
    });
  }
  refreshLocalUser() {
    if (!this.user) {
      //FAIL return;
    }

    let config = {
      headers: {
        Authorization: "Bearer " + this.user.token,
      },
    };
    return axios
      .get(process.env.VUE_APP_PUMAS_API_URL + "user", config)
      .then((response) => {
        console.log("NEW USER DATA");
        console.log(response);
        //this.user = response.data;
        this.user = Object.assign(this.user, response.data);
        console.log("this user");
        console.log(this.user);
        //this.user.name = response.data.name;
        cookies.set("flj-user", JSON.stringify(this.user));
        EventBus.$emit("user-state-change", this.user);
        return this.user;
      })
      .catch((error) => {
        //console.log('error login')
        //console.log(error)
        throw new Error(error);
      });
  }
  registerCustomer() {
    console.log("register customer");
    console.log(this.user);
    if (!this.user || !this.user.customer_id) {
      //FAIL return;
    }
    let config = {
      headers: {
        Authorization: "Bearer " + this.user.token,
      },
    };
    return axios
      .post(process.env.VUE_APP_PUMAS_API_URL + "customer", {}, config)
      .then((response) => {
        console.log(response);
        EventBus.$emit("user-state-change", response.data);
        return response.data;
      })
      .catch((error) => {
        //console.log('error login')
        //console.log(error)
        throw new Error(error);
      });
  }
  getCustomer() {
    console.log("get subsc");
    console.log(this.user);
    if (!this.user || !this.user.customer_id) {
      //FAIL return;
    }

    let config = {
      headers: {
        Authorization: "Bearer " + this.user.token,
      },
    };
    return axios
      .get(
        process.env.VUE_APP_PUMAS_API_URL + "customer/" + this.user.customer_id,
        config
      )
      .then((response) => {
        console.log(response);
        EventBus.$emit("user-state-change", response.data);
        return response.data;
      })
      .catch((error) => {
        //console.log('error login')
        //console.log(error)
        throw new Error(error);
      });
    console.log(this.user);
  }
  updateSource(token) {
    return this.get().then((user) => {
      let config = {
        headers: {
          Authorization: "Bearer " + user.token,
        },
      };

      return axios
        .post(
          process.env.VUE_APP_PUMAS_API_URL +
            "customer/" +
            user.customer_id +
            "/updateSource",
          token,
          config
        )
        .then((response) => {
          return response;
        })
        .catch((error) => {
          console.log("error update source");
          console.log(error);
          throw new Error(error);
        });
    });
  }
  setUsername(username) {
    let config = {
      headers: {
        Authorization: "Bearer " + this.user.token,
      },
    };
    console.log("set username");
    return axios
      .put(
        process.env.VUE_APP_PUMAS_API_URL + "user/name",
        { name: username },
        config
      )
      .then((response) => {
        return response;
      })
      .catch((error) => {
        throw new Error(error);
      });
  }
  getProductConfig() {
    let config = {
      headers: {
        Authorization: "Bearer " + this.user.token,
      },
    };
    return axios
      .get(process.env.VUE_APP_PUMAS_API_URL + "central/product-config", config)
      .then((response) => {
        return response;
      })
      .catch((error) => {
        //console.log('error login')
        //console.log(error)
        throw new Error(error);
      });
  }

  getIntent() {
    let config = {
      headers: {
        Authorization: "Bearer " + this.user.token,
      },
    };
    return axios

      .get(
        process.env.VUE_APP_PUMAS_API_URL +
          "customer/" +
          this.user.customer_id +
          "/intent",
        config
      )
      .then((response) => {
        return response;
      })
      .catch((error) => {
        //console.log('error login')
        //console.log(error)
        throw new Error(error);
      });
  }
  hasPaymentMethod(customer) {
    if (
      customer.sources &&
      customer.sources.total_count > 0 &&
      customer.sources.data[0] &&
      customer.sources.data[0].object &&
      customer.sources.data[0].object === "card"
    ) {
      return true;
    } else if (
      customer.invoice_settings &&
      customer.invoice_settings.default_payment_method
    ) {
      return true;
    } else {
      return false;
    }
  }
  getPaymentMethod(customer) {
    console.log(customer);

    return new Promise((resolve, reject) => {
      if (
        customer.invoice_settings &&
        customer.invoice_settings.default_payment_method
      ) {
        const paymentMethod = customer.invoice_settings.default_payment_method;
        console.log("PM");
        console.log(paymentMethod);
        this.getCardData(paymentMethod).then((data) => {
          console.log("data");
          console.log(data);
          return resolve(data);
        });
      } else if (
        customer.sources &&
        customer.sources.total_count > 0 &&
        customer.sources.data[0] &&
        customer.sources.data[0].object &&
        customer.sources.data[0].object === "card"
      ) {
        console.log(customer.sources.data[0]);
        const card = customer.sources.data[0];
        resolve(card);
      } else {
        return reject(false);
      }
    });
  }
  getCardData(paymentMethod) {
    let config = {
      headers: {
        Authorization: "Bearer " + this.user.token,
      },
    };
    return axios

      .get(
        process.env.VUE_APP_PUMAS_API_URL +
          "customer/" +
          this.user.customer_id +
          "/payment-method/" +
          paymentMethod,
        config
      )
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        //console.log('error login')
        //console.log(error)
        throw new Error(error);
      });
  }
  updatePaymentMethod(paymentMethod) {
    let config = {
      headers: {
        Authorization: "Bearer " + this.user.token,
      },
    };
    return axios

      .post(
        process.env.VUE_APP_PUMAS_API_URL +
          "customer/" +
          this.user.customer_id +
          "/payment-method",
        { paymentMethod: paymentMethod },
        config
      )
      .then((response) => {
        return response;
      })
      .catch((error) => {
        //console.log('error login')
        //console.log(error)
        throw new Error(error);
      });
  }

  getCoupon(coupon) {
    let config = {
      headers: {
        Authorization: "Bearer " + this.user.token,
      },
    };

    return axios
      .get(process.env.VUE_APP_PUMAS_API_URL + "coupon/" + coupon, config)
      .then((response) => {
        return response;
      })
      .catch((error) => {
        //console.log('error login')
        //console.log(error)
        throw new Error(error);
      });
  }

  setPassword(password) {
    let config = {
      headers: {
        Authorization: "Bearer " + this.user.token,
      },
    };

    return axios
      .put(
        process.env.VUE_APP_PUMAS_API_URL + "user/password",
        { password: password },
        config
      )
      .then((response) => {
        return response;
      })
      .catch((error) => {
        //console.log('error login')
        //console.log(error)
        throw new Error(error);
      });
  }

  addCoupon(coupon) {
    let config = {
      headers: {
        Authorization: "Bearer " + this.user.token,
      },
    };

    return axios
      .post(
        process.env.VUE_APP_PUMAS_API_URL + "coupon",
        { coupon: coupon },
        config
      )
      .then((response) => {
        return response;
      })
      .catch((error) => {
        //console.log('error login')
        //console.log(error)
        throw new Error(error);
      });
  }
  getInvoices() {
    let config = {
      headers: {
        Authorization: "Bearer " + this.user.token,
      },
    };
    return axios
      .get(process.env.VUE_APP_PUMAS_API_URL + "customer/invoices", config)
      .then(function(data) {
        return data;
      });
  }

  sendReciept(invoiceId) {
    let config = {
      headers: {
        Authorization: "Bearer " + this.user.token,
      },
    };
    return axios
      .get(
        process.env.VUE_APP_PUMAS_API_URL + "customer/sendreciept/" + invoiceId,
        config
      )
      .then(function(data) {
        return data;
      });
  }
  subscribe(coupon, plan = "") {
    console.log("SUBSCRIBE TO: " + plan);
    const couponObject = {};
    if (coupon) {
      couponObject.coupon = coupon;
    }
    console.log(this.user);
    let config = {
      headers: {
        Authorization: "Bearer " + this.user.token,
      },
    };
    return axios
      .post(
        process.env.VUE_APP_PUMAS_API_URL +
          "customer/" +
          this.user.customer_id +
          "/subscription" +
          (plan ? "/" + plan : ""),
        couponObject,
        config
      )
      .then((response) => {
        return response;
      });
  }
  resubscribe(sid) {
    console.log(this.user);
    if (!sid) {
      console.log("No subscription given");
    }
    let config = {
      headers: {
        Authorization: "Bearer " + this.user.token,
      },
    };
    return axios
      .post(
        process.env.VUE_APP_PUMAS_API_URL +
          "customer/" +
          this.user.customer_id +
          "/subscription/" +
          sid +
          "/resume",
        {},
        config
      )
      .then((response) => {
        return response;
      })
      .catch((error) => {
        //console.log('error login')
        //console.log(error)
        throw new Error(error);
      });
  }
  unsubscribe(sid) {
    if (!sid) {
      console.log("No subscription given");
    }
    let config = {
      headers: {
        Authorization: "Bearer " + this.user.token,
      },
    };
    return axios
      .post(
        process.env.VUE_APP_PUMAS_API_URL +
          "customer/" +
          this.user.customer_id +
          "/subscription/" +
          sid +
          "/cancel",
        {},
        config
      )
      .then((response) => {
        return response;
      })
      .catch((error) => {
        //console.log('error login')
        //console.log(error)
        throw new Error(error);
      });
  }
  getSubscriptionChangeOptions() {
    let config = {
      headers: {
        Authorization: "Bearer " + this.user.token,
      },
    };
    return axios
      .get(
        process.env.VUE_APP_PUMAS_API_URL +
          "customer/" +
          this.user.customer_id +
          "/subscription-change-options",
        config
      )
      .then((response) => {
        console.log("---");
        console.log(this.user);
        console.log(response);
        return response;
      })
      .catch((error) => {
        //console.log('error login')
        //console.log(error)
        throw new Error(error);
      });
  }
  changeSubscription(plan) {
    console.log(this.user);
    let config = {
      headers: {
        Authorization: "Bearer " + this.user.token,
      },
    };
    return axios
      .post(
        process.env.VUE_APP_PUMAS_API_URL +
          "customer/" +
          this.user.customer_id +
          "/change-subscription/" +
          plan,
        {},
        config
      )
      .then((response) => {
        return response;
      })
      .catch((error) => {
        //console.log('error login')
        //console.log(error)
        throw new Error(error);
      });
  }
}

export default {
  // The install method will be called with the Vue constructor as the first argument, along with possible options
  install(Vue, options) {
    const instance = new User();
    Vue.prototype.$userService = instance;
  },
};
